import { format } from 'date-fns';
import { nl } from 'date-fns/locale';

export function formatDateString(date: string | undefined | null): string {
    return date ? format(new Date(date), 'dd/MM/yyyy') : '';
}

export function formatDateTimeString(date: string | undefined | null): string {
    return date ? format(new Date(date), 'dd/MM/yyyy - HH:mm') : '';
}

export function formatDateStringToMonth(date: string | undefined): string {
    return date ? format(new Date(date), 'MM/yyyy') : '';
}

export function formatDateStringToQuarter(date: string | undefined): string {
    return date ? format(new Date(date), 'QQQ, yyyy') : '';
}

export function formatDateStringToYear(date: string | undefined): string {
    return date ? format(new Date(date), 'yyyy') : '';
}

export function formatEpoch(epoch: number): string {
    return epoch ? format(new Date(epoch), 'dd/MM/yyyy - HH:mm') : '';
}

export function formatMonth(month: number): string {
    return month ? format(new Date(2024, month, 1), 'LLLL', { locale: nl }) : '';
}
